export const columnStyle = {
  border: '1px solid #c2cad8',
  minHeight: '80px',
  backgroundColor: '#ffffff',
  width: '49%',
  margin: '0 7px 0 7px',
};

export const titleStyle = {
  padding: '8px 10px',
  borderBottom: '1px solid #c2cad8',
  marginBottom: '10px',
};

export const itemStyle = {
  padding: '4px 10px',
  backgroundColor: '#169BD5',
  margin: '0 20px 8px',
  color: '#ffffff',
};

export const subItemStyle = {
  padding: '4px 10px',
  backgroundColor: '#5AB3E8',
  margin: '0 20px 8px',
  color: '#ffffff',
};

export const disableItemStyle = {
  padding: '4px 10px',
  backgroundColor: 'gray',
  margin: '0 20px 8px',
  color: '#ffffff',
};

export const disableSubItemStyle = {
  padding: '4px 10px',
  backgroundColor: 'darkgray',
  margin: '0 20px 8px',
  color: '#ffffff',
};
